var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "BackView" },
    [
      !!_vm.to
        ? _c(
            "router-link",
            { staticClass: "BackViewButton", attrs: { to: _vm.to } },
            [
              _c("svg-view", { attrs: { name: "close" } }),
              _vm._v(" "),
              _vm._t("default"),
            ],
            2
          )
        : _c(
            "button",
            {
              staticClass: "BackViewButton",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleClick.apply(null, arguments)
                },
              },
            },
            [
              _c("svg-view", { attrs: { name: "close" } }),
              _vm._v(" "),
              _vm._t("default"),
            ],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }